<template>
    <BoardComponent
        :options="boardOptions"
    />
</template>

<script>
// https://local.boxed.bryter-custom.io/vendor-onboarding-hub/board/board/?env=4NkpRB7lT4mdt_TsSRogQg&a=2&vue
import BoardComponent from '@vueapp/components/BoardComponent.vue'

export default {
    components: {
        BoardComponent
    },
    data() {
        return {
            boardOptions: {
                board: {
                    label: '',
                    board_data: {},
                    database_data: {},
                    post: {},
                    status_badge_header: false,
                    vw: false
                },
                body_class: '',
                post: {}
            }
        }
    },
    props: {
        postSlug: String,
        postId: String,
        isViewWrapper: String
    },
    methods: {

    },

    async beforeCreate() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        fetch( BRYTER.homeUrl + '/board/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                this.boardOptions = data
                this.boardOptions.board = data.board

                if(this.isViewWrapper === 'true') {
                    this.boardOptions.board.vw = true
                }
            })
            .catch(error => {
                console.error('Error fetching calendar data:', error);
            });
    }
}
</script>